import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {MissionIdentifier} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/mission.types';
import {CoinsService_ClaimMissionRewardLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.grpc.lazy';
import {useCustomerSession} from '@aboutyou/user';
import {useCallback} from 'react';

export const useClaimMissionReward = () => {
  const customerSession = useCustomerSession();
  const mutation = useGrpcRequestMutation(CoinsService_ClaimMissionRewardLazy, {
    disabled: !customerSession,
  });

  const claimMissionReward = useCallback(
    async (missionIdentifier: MissionIdentifier) => {
      return mutation.mutateAsync({
        missionIdentifier,
        session: customerSession!,
      });
    },
    [customerSession, mutation],
  );

  return {
    claimMissionReward,
    isPending: mutation.isPending,
  };
};
